(function () {

  const MATERIALS = {
    stone: [
      {
        name: 'Malachite',
        image: 'https://cdn.shopify.com/s/files/1/2100/7465/files/Malachite.jpg?v=1763008940'
      },
      {
        name: 'Apatite',
        image: 'https://cdn.shopify.com/s/files/1/2100/7465/files/Apitite_Stone.jpg?v=1763008940'
      },
      {
        name: 'Blue Lace Agate',
        image: 'https://cdn.shopify.com/s/files/1/2100/7465/files/Blue_-_Lace_Agate.jpg?v=1763008939'
      },
      {
        name: 'Aura White Howlite',
        image: 'https://cdn.shopify.com/s/files/1/2100/7465/files/Aura_white_howlite.jpg?v=1763008940'
      },
      {
        name: 'Lapis Lazuli',
        image: 'https://cdn.shopify.com/s/files/1/2100/7465/files/Lapis_Lazuli.jpg?v=1763008940'
      },
      {
        name: 'Agatized Dino Bone',
        image: 'https://cdn.shopify.com/s/files/1/2100/7465/files/Agatized_Dino_Bone.jpg?v=1763008940'
      }
    ],

    wood: [
      {
        name: 'Walnut',
        image: 'https://cdn.shopify.com/s/files/1/2100/7465/files/walnut.jpg?v=1763008850'
      },
      {
        name: 'Ashwood',
        image: 'https://cdn.shopify.com/s/files/1/2100/7465/files/ash.webp?v=1763008852'
      },
      {
        name: 'Sapele',
        image: 'https://cdn.shopify.com/s/files/1/2100/7465/files/sapele.jpg?v=1763008851'
      },
      {
        name: 'Blood Oak',
        image: 'https://cdn.shopify.com/s/files/1/2100/7465/files/blood_oak.jpg?v=1763008852'
      }
    ]
  };


  function init(root) {

    if (root.dataset.twReady === 'true') return;

    root.dataset.twReady = 'true';


    let route = 'later';
    let inlayMode = 'same';


    const routeButtons =
      root.querySelectorAll('[data-route]');

    const customCollapse =
      root.querySelector('[data-custom-collapse]');

    const featureInputs =
      root.querySelectorAll('[data-feature]');

    const crestCollapse =
      root.querySelector('[data-crest-collapse]');

    const fingerprintCollapse =
      root.querySelector('[data-fingerprint-collapse]');

    const crestInput =
      root.querySelector('[data-crest-input]');

    const fingerprintInput =
      root.querySelector('[data-fingerprint-input]');

    const modeButtons =
      root.querySelectorAll('[data-inlay-mode]');

    const layouts =
      root.querySelectorAll('[data-inlay-layout]');

    const variant =
      root.querySelector('[data-ring-variant]');

    const addButton =
      root.querySelector('[data-add-button]');

    const addText =
      root.querySelector('[data-add-text]');

    const pRoute =
      root.querySelector('[data-property-route]');

    const pFeature =
      root.querySelector('[data-property-feature]');

    const pLeft =
      root.querySelector('[data-property-left]');

    const pRight =
      root.querySelector('[data-property-right]');

    const pLayout =
      root.querySelector('[data-property-layout]');

    const summary =
      root.querySelector('.tw-summary');

    const sSize =
      root.querySelector('[data-summary-size]');

    const sRoute =
      root.querySelector('[data-summary-route]');

    const sFeature =
      root.querySelector('[data-summary-feature]');

    const sLeft =
      root.querySelector('[data-summary-left]');

    const sRight =
      root.querySelector('[data-summary-right]');

    const sameLabel =
      root.querySelector('[data-same-label]');

    const leftLabel =
      root.querySelector('[data-left-label]');

    const rightLabel =
      root.querySelector('[data-right-label]');

    const whatsapp =
      root.querySelector('[data-whatsapp]');


    function renderMaterials() {

      root
        .querySelectorAll('[data-material-selector]')
        .forEach(function (selector) {

          const side =
            selector.dataset.materialSelector;

          selector
            .querySelectorAll('[data-material-grid]')
            .forEach(function (grid) {

              const type =
                grid.dataset.materialGrid;

              grid.innerHTML = '';

              MATERIALS[type].forEach(function (material) {

                const label =
                  document.createElement('label');

                label.className =
                  'tw-material-card';

                label.innerHTML =
                  '<input type="radio"' +
                  ' name="tw_' + side + '_' + root.dataset.uid + '"' +
                  ' value="' + material.name + '"' +
                  ' data-material-choice="' + side + '">' +

                  '<span class="tw-material-card__inner">' +

                    '<span class="tw-material-card__image">' +

                      '<img src="' +
                      material.image +
                      '" alt="' +
                      material.name +
                      '" loading="lazy">' +

                    '</span>' +

                    '<span class="tw-material-card__name">' +
                    material.name +
                    '</span>' +

                  '</span>';

                grid.appendChild(label);

              });

            });

        });


      root
        .querySelectorAll('[data-material-choice]')
        .forEach(function (input) {

          input.addEventListener(
            'change',
            update
          );

        });

    }


    function initTabs() {

      root
        .querySelectorAll('[data-material-selector]')
        .forEach(function (selector) {

          const tabs =
            selector.querySelectorAll('[data-material-tab]');

          const panels =
            selector.querySelectorAll('[data-material-panel]');


          tabs.forEach(function (tab) {

            tab.addEventListener('click', function () {

              const type =
                tab.dataset.materialTab;


              tabs.forEach(function (item) {

                item.classList.toggle(
                  'is-selected',
                  item === tab
                );

              });


              panels.forEach(function (panel) {

                panel.classList.toggle(
                  'is-active',
                  panel.dataset.materialPanel === type
                );

              });

            });

          });

        });

    }


    function getFeature() {

      return root.querySelector(
        '[data-feature]:checked'
      );

    }


    function getMaterial(side) {

      return root.querySelector(
        '[data-material-choice="' +
        side +
        '"]:checked'
      );

    }


    function getSize() {

      if (!variant) return '';

      if (variant.tagName === 'SELECT') {

        const option =
          variant.options[
            variant.selectedIndex
          ];

        return option
          ? (
              option.dataset.title ||
              option.textContent.trim()
            )
          : '';

      }

      return root.dataset.defaultSize || '';

    }


    function setRoute(value) {

      route = value;

      routeButtons.forEach(function (button) {

        const active =
          button.dataset.route === value;

        button.classList.toggle(
          'is-selected',
          active
        );

        button.setAttribute(
          'aria-pressed',
          active ? 'true' : 'false'
        );

      });

      customCollapse.classList.toggle(
        'is-open',
        value === 'custom'
      );

      summary.classList.toggle(
        'is-custom',
        value === 'custom'
      );

      update();

    }


    function setInlayMode(value) {

      inlayMode = value;

      modeButtons.forEach(function (button) {

        button.classList.toggle(
          'is-selected',
          button.dataset.inlayMode === value
        );

      });

      layouts.forEach(function (layout) {

        layout.classList.toggle(
          'is-open',
          layout.dataset.inlayLayout === value
        );

      });

      update();

    }


    function updateUploads() {

      const feature =
        getFeature();

      const value =
        feature ? feature.value : '';

      const crest =
        route === 'custom' &&
        value === 'Crest';

      const fingerprint =
        route === 'custom' &&
        value === 'Fingerprint';


      crestCollapse.classList.toggle(
        'is-open',
        crest
      );

      fingerprintCollapse.classList.toggle(
        'is-open',
        fingerprint
      );


      if (crestInput) {
        crestInput.disabled = !crest;
      }

      if (fingerprintInput) {
        fingerprintInput.disabled = !fingerprint;
      }

    }


    function updateProperties() {

      const feature =
        getFeature();

      const same =
        getMaterial('same');

      const left =
        getMaterial('left');

      const right =
        getMaterial('right');


      if (route === 'later') {

        pRoute.value =
          'Order now — finalise later';

        pFeature.value =
          'To be confirmed';

        pLeft.value =
          'To be confirmed';

        pRight.value =
          'To be confirmed';

        pLayout.value =
          'To be confirmed';

        return;

      }


      pRoute.value =
        'Customise now';

      pFeature.value =
        feature
          ? feature.value
          : 'To be confirmed';


      if (inlayMode === 'same') {

        const value =
          same
            ? same.value
            : 'To be confirmed';

        pLeft.value = value;
        pRight.value = value;

        pLayout.value =
          'Same on both sides';

      } else {

        pLeft.value =
          left
            ? left.value
            : 'To be confirmed';

        pRight.value =
          right
            ? right.value
            : 'To be confirmed';

        pLayout.value =
          'Different on each side';

      }

    }


    function updateSummary() {

      const feature =
        getFeature();

      const same =
        getMaterial('same');

      const left =
        getMaterial('left');

      const right =
        getMaterial('right');


      sSize.textContent =
        getSize();


      if (route === 'later') {

        sRoute.textContent =
          'Finalise later';

        return;

      }


      sRoute.textContent =
        'Customising now';


      sFeature.textContent =
        feature
          ? feature.value
          : 'To be confirmed';


      if (inlayMode === 'same') {

        const value =
          same
            ? same.value
            : 'To be confirmed';

        sLeft.textContent = value;
        sRight.textContent = value;

      } else {

        sLeft.textContent =
          left
            ? left.value
            : 'To be confirmed';

        sRight.textContent =
          right
            ? right.value
            : 'To be confirmed';

      }

    }


    function updateLabels() {

      const same =
        getMaterial('same');

      const left =
        getMaterial('left');

      const right =
        getMaterial('right');


      sameLabel.textContent =
        same
          ? same.value
          : 'Select material';

      leftLabel.textContent =
        left
          ? left.value
          : 'Select material';

      rightLabel.textContent =
        right
          ? right.value
          : 'Select material';

    }


    function updateAvailability() {

      if (
        !variant ||
        variant.tagName !== 'SELECT'
      ) return;


      const option =
        variant.options[
          variant.selectedIndex
        ];

      if (!option) return;


      const available =
        option.dataset.available === 'true';


      addButton.disabled =
        !available;

      addText.textContent =
        available
          ? 'ADD TO CART'
          : 'SOLD OUT';

    }


    function update() {

      updateUploads();
      updateProperties();
      updateSummary();
      updateLabels();
      updateAvailability();

    }


    routeButtons.forEach(function (button) {

      button.addEventListener(
        'click',
        function () {

          setRoute(
            button.dataset.route
          );

        }
      );

    });


    featureInputs.forEach(function (input) {

      input.addEventListener(
        'change',
        update
      );

    });


    modeButtons.forEach(function (button) {

      button.addEventListener(
        'click',
        function () {

          setInlayMode(
            button.dataset.inlayMode
          );

        }
      );

    });


    if (variant) {

      variant.addEventListener(
        'change',
        update
      );

    }


    if (whatsapp) {

      whatsapp.addEventListener(
        'click',
        function () {

          const feature =
            getFeature();

          const same =
            getMaterial('same');

          const left =
            getMaterial('left');

          const right =
            getMaterial('right');


          let featureText =
            'To be confirmed';

          let leftText =
            'To be confirmed';

          let rightText =
            'To be confirmed';


          if (route === 'custom') {

            if (feature) {
              featureText =
                feature.value;
            }


            if (inlayMode === 'same') {

              if (same) {

                leftText =
                  same.value;

                rightText =
                  same.value;

              }

            } else {

              if (left) {
                leftText =
                  left.value;
              }

              if (right) {
                rightText =
                  right.value;
              }

            }

          }


          const message =
            'Hi Touchwood 👋\n\n' +
            'I would like to discuss this ring:\n\n' +
            root.dataset.productTitle + '\n' +
            'Size: ' + getSize() + '\n' +
            'Main feature: ' + featureText + '\n' +
            'Left inlay: ' + leftText + '\n' +
            'Right inlay: ' + rightText + '\n\n' +
            root.dataset.productUrl;


          window.open(
            'https://wa.me/27842994583?text=' +
            encodeURIComponent(message),
            '_blank'
          );

        }
      );

    }


    renderMaterials();
    initTabs();

    setRoute('later');
    setInlayMode('same');

    update();

  }


  function initAll() {

    document
      .querySelectorAll('[data-tw-ring-builder]')
      .forEach(init);

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );

  } else {

    initAll();

  }


  document.addEventListener(
    'shopify:section:load',
    initAll
  );

})();